export default "__VITE_ASSET__DwMFfAME__"